import React, { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import AvailabilitySummarySection from '@/pages/Profile/components/AvailabilitySummarySection';
import { hasPermission, PEOPLE_AVAILABILITY_VIEW } from '@/utils/userPermission';

/**
 * The member's hours alone. The profile reaches the same summary through
 * MemberAvailabilitySection, which adds the notes and a heading of its own.
 */
const PersonAvailabilitySummary = () => {
  const { permissions } = useContext(AppContext);

  if (!hasPermission({ permissions, requiredPermission: PEOPLE_AVAILABILITY_VIEW })) return null;

  return (
    <div className="mt-2">
      <AvailabilitySummarySection showEditAction={false} showHeader={false} />
    </div>
  );
};

export default React.memo(PersonAvailabilitySummary);
